(ns scittle.cljs-bean
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [cljs-bean.core]))

;; Plugin: cljs-bean
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::cljs-bean
   {:namespaces
   {'cljs-bean.core (sci/copy-ns cljs-bean.core (sci/create-ns 'cljs-bean.core nil))}}
   ))
